import { Routes } from '@angular/router';

export const MY_APPS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: async () =>
      (await import('../features/pages/index/index.component')).IndexComponent
  }
];
